import { reflect } from '@effector/reflect';
import { AppShell, Select } from '@mantine/core';
import { useUnit } from 'effector-react';
import { createEditGameSettingModal } from 'features/edit-game-setting';
import { createResetGameSettingModal } from 'features/reset-game-setting';
import { createGameSettingRegistry } from 'entities/game-setting';
import { translated } from 'shared/lib';
import { gameSettingsPageModel } from '../../model';
import cls from './game-settings-page.module.scss';

const GameSettingsRegistry = createGameSettingRegistry(
	gameSettingsPageModel.gameSettingsRegistryModel,
);

const ResetGameSettingModal = createResetGameSettingModal(
	gameSettingsPageModel.resetGameSettingModel,
);

const EditGameSettingModal = createEditGameSettingModal(gameSettingsPageModel.editGameSettingModel);

const GameFilter = reflect({
	view: Select,
	bind: {
		'data-test-id': 'game-settings-page-game-filter',
		value: gameSettingsPageModel.$gameId.map((id) => `${id}`),
		data: gameSettingsPageModel.$games,
		label: translated('account-page.game'),
		searchable: true,
		clearable: false,
	},
});

export const GameSettingsPage = () => {
	const game = useUnit(gameSettingsPageModel.$game);

	return (
		<>
			<AppShell.Main className={cls.gameSettingsPage}>
				<GameSettingsRegistry
					filterSlot={<GameFilter />}
					className={cls.gameSettingsPageRegistry}
					tableTdActionSlot={(setting) =>
						game !== null && (
							<div className={cls.gameSettingsPageActions}>
								<EditGameSettingModal.ActionIcon modalData={{ ...setting, game }} />
								<ResetGameSettingModal.ActionIcon modalData={{ ...setting, game }} />
							</div>
						)
					}
				/>
			</AppShell.Main>
			<ResetGameSettingModal />
			<EditGameSettingModal />
		</>
	);
};
